"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.animationFadeInMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
var _animationA11yMixin = require("./animationA11yMixin");
var fadeInKeyframes = /*#__PURE__*/(0, _styledComponents.keyframes)(["from{opacity:0;}to{opacity:1;}"]);

/** @mixin animationFadeInMixin */
/**
 * Adds a fade in animation to a component that meets a11y standards.
 *
 * @example
 * import { animationFadeInMixin } from '@zillow/constellation';
 *
 * const Component = styled.div`
 *     ${animationFadeInMixin}
 * `;
 *
 * <Component>My animated component</Component>
 *
 * @method
 * @return {CSSObject}
 */
var animationFadeInMixin = (0, _styledToken.default)({
  duration: 'animations.defaultDuration',
  timing: 'animations.defaultTimingFunction'
}, function (tokens) {
  return (0, _animationA11yMixin.animationA11yMixin)((0, _styledComponents.css)(["animation:", " ", "s ", ";"], fadeInKeyframes, tokens.duration, tokens.timing));
});
exports.animationFadeInMixin = animationFadeInMixin;